import React, { Component } from 'react'
import { getImgSrc, isNegative, parseHTML, signedRoundOff, toTitleCase } from '../../helpers/GlobalFunctions';

export default class TSAComponents extends Component {
	/**
	 * @description Function to get customize the format of screw data
	 * @returns Custom object with necessary data to show
	 * @memberof TSAComponents
	 */
	getScrewText = (screwInfoString) => {
		let screwType = screwInfoString.substring(0, screwInfoString.indexOf(' ')).toLowerCase();
		let screwSizeText = screwInfoString.substring(screwInfoString.lastIndexOf(' ') + 1);
		let screwTypeText = 'Lock';
		switch (screwType) {
			case 'locking':
				screwTypeText = 'Lock';
				break;

			default:
				break;
		}

		return {
			screwType,
			screwSizeText,
			screwTypeText,
			screwSize: !isNaN(parseFloat(screwSizeText)) ? parseFloat(screwSizeText) : null
		}
	}

	/**
	 * @description Function to get necessary data from the caseIntraOp data
	 * @returns Custom object with necessary data to show
	 * @memberof TSAComponents
	 */
	getIntraOpData = () => {
		const { caseIntraOp, operativeApproach } = this.props;
		if (!caseIntraOp) {
			return null;
		}
		const initialPlan = caseIntraOp?.plan?.Initial || null;
		const finalPlan = caseIntraOp?.plan?.FinalPlan || null;
		const screwDataResponse = initialPlan?.Implant?.[`scapula_${operativeApproach}`]?.Identifier || null;

		return {
			humerus: {
				stemInclinationAngle: finalPlan?.Implant[`humerus_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.stemInclinationAngle || '',
				stemVersionAngle: finalPlan?.Implant[`humerus_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.stemVersionAngle || '',
				stemDepth: finalPlan?.Implant[`humerus_${operativeApproach}`]?.Placement?.Metrics?.ResectionDepth?.stemDepth || '',
			},
			scapula: {
				glenoidAnteriorDepth: finalPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ResectionDepth?.glenoidAnteriorDepth || '',
				glenoidCentralDepth: finalPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ResectionDepth?.glenoidCentralDepth || '',
				glenoidInferiorDepth: finalPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ResectionDepth?.glenoidInferiorDepth || '',
				glenoidPosteriorDepth: finalPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ResectionDepth?.glenoidPosteriorDepth || '',
				glenoidSuperiorDepth: finalPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ResectionDepth?.glenoidSuperiorDepth || ''
			},
			glenoid: {
				native: {
					nativeInclinationAngle: initialPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.nativeInclinationAngle || '',
					nativeVersionAngle: initialPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.nativeVersionAngle || ''
				},
				final: {
					glenoidInclinationCorrection: finalPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.glenoidInclinationCorrection || '',
					glenoidVersionCorrection: finalPlan?.Implant[`scapula_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.glenoidVersionCorrection || ''
				}
			},
			screws: {
				screwA: screwDataResponse?.screwA ? this.getScrewText(screwDataResponse?.screwA) : null,
				screwB: screwDataResponse?.screwB ? this.getScrewText(screwDataResponse?.screwB) : null,
				screwC: screwDataResponse?.screwC ? this.getScrewText(screwDataResponse?.screwC) : null,
				screwD: screwDataResponse?.screwD ? this.getScrewText(screwDataResponse?.screwD) : null,
				screwE: screwDataResponse?.screwE ? this.getScrewText(screwDataResponse?.screwE) : null
			}
		}
	}
	render() {
		const { caseDetails, operativeApproach } = this.props;
		const operativeSide = caseDetails?.operativeSide?.toString()?.toLowerCase() || 'right';
		const leftImage = operativeApproach === 'anatomic' ? 'shoulder_anatomic_humerus.png' : 'shoulder_reverse_humerus.png';
		const middleImage = operativeApproach === 'anatomic' ? 'shoulder_anatomic_implant.png' : 'shoulder_reverse_implant.png';
		const rightImage = operativeApproach === 'reverse' ? (operativeSide === 'left' ? 'shoulder_implant_left.png' : 'shoulder_implant_right.png') : '';
		const intraOpData = this.getIntraOpData();
		return (
			<div className={`components-body tsa-component-wrap ${operativeApproach}`}>
				<div className="card">
					<div className="card-body">
						<h2 className="card-title">Components</h2>
						<div className="row">
							{/* Left Image */}
							<div className={`${operativeApproach === "reverse" ? 'col-md-3' : 'col-md-6'} case-component-div case-component-border`}>
								<div className="case-text-align-below">
									<span className="tsa-component-text">Humerus Inclination</span>
									<span className="tsa-component-text">{intraOpData?.humerus?.stemInclinationAngle ? parseHTML(`${signedRoundOff(intraOpData?.humerus?.stemInclinationAngle)}&deg;`) : 'N/A'}</span>
								</div>

								<div className="align-image-text">
									<img className={`img-bg-color ${operativeSide === 'right' ? 'flip-image' : ''}`} src={getImgSrc(leftImage)} alt={`Humerus ${toTitleCase(operativeSide)}`} />
									<div className="depth-text-wrap">
										<span className="tsa-component-text">Depth</span>
										<span className="tsa-component-text">{intraOpData?.humerus?.stemDepth ? `${signedRoundOff(intraOpData?.humerus?.stemDepth)}mm` : 'N/A'}</span>
									</div>
								</div>

								<div className="case-text-align-below case-text-lower-row">
									<span className="tsa-component-text">{intraOpData?.humerus?.stemVersionAngle ? parseHTML(`${signedRoundOff(intraOpData?.humerus?.stemVersionAngle)}&deg;`) : 'N/A'}</span>
									<span className="tsa-component-text">Humerus Version</span>
								</div>
							</div>

							{/* Middle Image */}
							<div className={`${operativeApproach === "reverse" ? 'col-md-4' : 'col-md-6'} case-component-div ${operativeApproach === "reverse" ? 'case-component-border' : ''}`}>
								<div className="d-flex flex-column align-items-stretch justify-content-around h-100 middle-image-wrap">
									<div className="top-section">
										<span className="d-inline-block rounded-bg yellow" title="Glenoid Superior Depth">S</span>
										<span className="d-block distance-text yellow">{intraOpData?.scapula?.glenoidSuperiorDepth ? `${signedRoundOff(intraOpData?.scapula?.glenoidSuperiorDepth)}mm` : 'N/A'}</span>
									</div>
									<div className="d-flex align-items-center justify-content-evenly image-section">
										<div className="left-section">
											<span className="d-inline-block rounded-bg blue" title="Glenoid Posterior Depth">P</span>
											<span className="d-block distance-text blue">{intraOpData?.scapula?.glenoidPosteriorDepth ? `${signedRoundOff(intraOpData?.scapula?.glenoidPosteriorDepth)}mm` : 'N/A'}</span>
										</div>
										<img className={`img-bg-color ${operativeSide === 'right' ? 'flip-image' : ''}`} src={getImgSrc(middleImage)} alt={`Scapula ${toTitleCase(operativeSide)}`} />
										<div className="right-section">
											<span className="d-inline-block rounded-bg purple" title="Glenoid Anterior Depth">A</span>
											<span className="d-block distance-text purple">{intraOpData?.scapula?.glenoidAnteriorDepth ? `${signedRoundOff(intraOpData?.scapula?.glenoidAnteriorDepth)}mm` : 'N/A'}</span>
										</div>
									</div>
									<div className="bottom-section">
										<span className="d-inline-block rounded-bg teal" title="Glenoid Inferior Depth">I</span>
										<span className="d-block distance-text teal">{intraOpData?.scapula?.glenoidInferiorDepth ? `${signedRoundOff(intraOpData?.scapula?.glenoidInferiorDepth)}mm` : 'N/A'}</span>
									</div>
								</div>
							</div>

							{/* Right Image */}
							{operativeApproach === "reverse" ?
								<div className="col-md-5 case-component-div">
									<div className="d-flex align-items-center justify-content-evenly h-100 right-image-wrap">
										<div className="left-section">
											<label className="d-block right-panel-header">Planned Screws</label>
											<ul className="list-unstyled m-0 right-panel-index-list">
												<li>
													<span className="right-panel-icon">A: </span>
													<span className="right-panel-text">
														{intraOpData?.screws?.screwA?.screwType ?
															<><span className="number-font">{intraOpData?.screws?.screwA?.screwSize}</span>mm {intraOpData?.screws?.screwA?.screwTypeText}</>
															: <span className="number-font">-</span>}
													</span>
												</li>
												<li>
													<span className="right-panel-icon">B: </span>
													<span className="right-panel-text">
														{intraOpData?.screws?.screwB?.screwType ?
															<><span className="number-font">{intraOpData?.screws?.screwB?.screwSize}</span>mm {intraOpData?.screws?.screwB?.screwTypeText}</>
															: <span className="number-font">-</span>}
													</span>
												</li>
												<li>
													<span className="right-panel-icon">C: </span>
													<span className="right-panel-text">
														{intraOpData?.screws?.screwC?.screwType ?
															<><span className="number-font">{intraOpData?.screws?.screwC?.screwSize}</span>mm {intraOpData?.screws?.screwC?.screwTypeText}</>
															: <span className="number-font">-</span>}
													</span>
												</li>
												<li>
													<span className="right-panel-icon">D: </span>
													<span className="right-panel-text">
														{intraOpData?.screws?.screwD?.screwType ?
															<><span className="number-font">{intraOpData?.screws?.screwD?.screwSize}</span>mm {intraOpData?.screws?.screwD?.screwTypeText}</>
															: <span className="number-font">-</span>}
													</span>
												</li>
												<li>
													<span className="right-panel-icon">E: </span>
													<span className="right-panel-text">
														{intraOpData?.screws?.screwE?.screwType ?
															<><span className="number-font">{intraOpData?.screws?.screwE?.screwSize}</span>mm {intraOpData?.screws?.screwE?.screwTypeText}</>
															: <span className="number-font">-</span>}
													</span>
												</li>
											</ul>
										</div>
										<img className="img-bg-color" src={getImgSrc(rightImage)} alt="Screw Type" />
									</div>
								</div>
								: ''}
						</div>
						<div className="row glenoid-wrap">
							<div className="col-6 mt-2 ps-0">
								<label className="glenoid-header">Glenoid Native</label>
								<table className="table table-bordered glenoid-table m-0">									
									<tbody>
										<tr>
											<td className="text-left">{isNegative(intraOpData?.glenoid?.native?.nativeInclinationAngle) ? 'Inferior' : 'Superior'} Inclination</td>
											<td>{intraOpData?.glenoid?.native?.nativeInclinationAngle ? parseHTML(`${signedRoundOff(intraOpData?.glenoid?.native?.nativeInclinationAngle)}&deg;`) : 'N/A'}</td>
										</tr>
										<tr>
											<td className="text-left">{isNegative(intraOpData?.glenoid?.native?.nativeVersionAngle) ? 'Retroversion' : 'Anteversion'}</td>
											<td>{intraOpData?.glenoid?.native?.nativeVersionAngle ? parseHTML(`${signedRoundOff(intraOpData?.glenoid?.native?.nativeVersionAngle)}&deg;`) : 'N/A'}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div className="col-6 mt-2 pe-0">
								<label className="glenoid-header">Glenoid Final</label>
								<table className="table table-bordered glenoid-table m-0">
									<tbody>
										<tr>
											<td className="text-left">{isNegative(intraOpData?.glenoid?.final?.glenoidInclinationCorrection) ? 'Inferior' : 'Superior'} Inclination</td>
											<td>{intraOpData?.glenoid?.final?.glenoidInclinationCorrection ? parseHTML(`${signedRoundOff(intraOpData?.glenoid?.final?.glenoidInclinationCorrection)}&deg;`) : 'N/A'}</td>
										</tr>
										<tr>
											<td className="text-left">{isNegative(intraOpData?.glenoid?.final?.glenoidVersionCorrection) ? 'Retroversion' : 'Anteversion'}</td>
											<td>{intraOpData?.glenoid?.final?.glenoidVersionCorrection ? parseHTML(`${signedRoundOff(intraOpData?.glenoid?.final?.glenoidVersionCorrection)}&deg;`) : 'N/A'}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
